export default __webpack_public_path__ + "static/cabin-deluxe-2-to-4-2-098ad6f2191922dba2d9b957fe81b8ca.jpg";